import ApprovedPPA from './ApprovedPPA'

export default ApprovedPPA